// extracted by mini-css-extract-plugin
export default {"container":"SectionLayout_container__50X5s","left":"SectionLayout_left__VqpHw","right":"SectionLayout_right__n+DwM"};